import { QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Route, Routes } from "react-router-dom";

import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { GuidePage } from "../pages/GuidePage";
import { HomePage } from "../pages/HomePage";
import { NotFoundPage } from "../pages/NotFoundPage";
import { queryClient } from "./query-client";

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <div className="app-shell">
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/pdf-to-word" element={<HomePage />} />
            <Route path="/guide" element={<GuidePage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <Footer />
        </div>
      </HashRouter>
    </QueryClientProvider>
  );
}
